/**
 * DISA Theme Overrides
 * Client-specific design tokens for DISA energy company
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/disa/disa.png';

export const disaThemeOverrides: ClientThemeOverrides = {
  clientId: 'disa',
  logo,
  clientName: 'DISA',
  palette: {
    light: {
      primary: {
        main: '#1C5CA3',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#1C5CA3',
        contrastText: '#ffffff',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#1C5CA3',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#3D3510',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
    dark: {
      primary: {
        main: '#4d8bc9',
        contrastText: '#000000',
      },
      secondary: {
        main: '#4d8bc9',
        contrastText: '#000000',
      },
      background: {
        default: '#121212',
        paper: '#1E1E1E',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.87)',
        secondary: 'rgba(255, 255, 255, 0.6)',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#1C5CA3',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#5a4d1c',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
  },
  typography: {
    h4: {
      color: 'rgba(0, 0, 0, 0.77)',
    },
    h5: {
      color: 'rgba(0, 0, 0, 0.77)',
    },
  },
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          minWidth: '100px',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
            height: '100%',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          '&.flat': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '& .MuiCardActions-root': {
              justifyContent: 'flex-end',
            },
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '&.noPadding': {
            padding: '0px !important',
          },
        },
      },
    },
  },
};
